import React, { PropsWithChildren } from 'react';
import Utilities from '@util/Utilities';
import { TagState, toColor } from '@app/component/tag/TagState';

const Tag: React.FunctionComponent<PropsWithChildren<{ state: TagState, extraClassName?: string, title?: string }>> = ({
																																																												 children,
																																																												 state,
																																																												 extraClassName,
																																																												 title,
																																																											 }) => {

	const color = toColor(state);

	const backgroundColor = (state === 'availabilityHighWarning' || state === 'availabilityLowWarning') ? 'slate' : color;

	const className = Utilities.classNames(
		`inline-flex items-center rounded-md bg-${backgroundColor}-50 px-2 py-1 text-xs font-medium ${state === 'none' ? 'text-slate-400' : 'text-' + color + '-700'} ring-1 ring-inset ring-${backgroundColor}-700/10`,
		!!extraClassName ? extraClassName : '',
	);

	return <span className={className} title={title}>{children}</span>;

};

export default Tag;